import atlasAPI from '../services/atlasAPI'

const schedule = {
  data() {
    return {
      myscheduleid: localStorage.getItem("myscheduleid") || "",
      revertmyschedule: localStorage.getItem("revertmyschedule") || "",
      schedule: JSON.parse(localStorage.getItem("schedule")) || [],
    };
  },
  methods: {
    schedule_edit: function (id) {
      id = String(id);

      // Turn the array into a Set
      const set = new Set(this.schedule);

      // Toggle session id presence
      set.has(id) ? set.delete(id) : set.add(id);

      // Write it back as an array
      this.schedule = Array.from(set);

      // Persist + update store + sync with cloud
      localStorage.setItem("schedule", JSON.stringify(this.schedule));
      this.$store.dispatch("counterUpdate", { count: this.schedule.length });
      this.updateCloudSchedule();
    },
    schedule_includes: function (id) {
      // this.schedule insead of local storage for reactivity
      return this.schedule.includes(String(id));
    },
    async schedule_createSchedule(email) {
      const payload = {
        sessions: this.schedule,
      };
      try {
        const response = await atlasAPI.post("createSchedule", payload);
        const id = response.data.insertedId;
        this.myscheduleid = id;
        localStorage.setItem("myscheduleid", id);
        atlasAPI.sendCreateScheduleEmail(email, id);
        this.$router.push({
          name: "MySchedule",
          params: { id },
        });
      } catch (error) {
        console.error(error);
      }
    },
    schedule_revertSchedule: function () {
      this.myscheduleid = this.revertmyschedule;
      localStorage.setItem("myscheduleid", this.revertmyschedule);
      this.revertmyschedule = "";
      localStorage.setItem("revertmyschedule", "");
      this.$router.push({
        name: "MySchedule",
        params: { id: this.myscheduleid }
      });
      this.getSchedule();
    },
    async getSchedule() {
      let lookupid = false;
      if (this.$route.params.id && this.$route.query.nochange) {
        // replace revertmyschedule if myscheduleid not empty
        this.revertmyschedule = this.myscheduleid || this.revertmyschedule; // || (case when looking at two other's schedule in a row)
        this.myscheduleid = "";
        lookupid = this.$route.params.id;
      } else if (this.$route.params.id) {
        this.myscheduleid = this.$route.params.id;
        lookupid = this.$route.params.id;
      } else {
        lookupid = this.myscheduleid;
      }

      localStorage.setItem("revertmyschedule", this.revertmyschedule);
      localStorage.setItem("myscheduleid", this.myscheduleid);

      if (!lookupid) return;
      try {
        const response = await atlasAPI.get('getSchedule?id=' + lookupid);
        if (response.data.sessions) {
          localStorage.setItem(
            "schedule",
            JSON.stringify(response.data.sessions)
          );
          this.schedule = response.data.sessions;
          this.$store.dispatch("counterUpdate", { count: this.schedule.length });
        }
      } catch (error) {
        console.error(error);
      }
    },
    updateCloudSchedule: function () {
      if (!this.myscheduleid) {
        // This in combination with setting empty this.myschedule in getSchedule prevents changes to other's schedule
        return;
      }
      const payload = {
        sessions: this.schedule,
        id: this.myscheduleid
      }
      try {
        atlasAPI.put('updateSchedule', payload);
      } catch (error) {
        console.error(error);
      }
    },
  },

  mounted: function () {
    this.getSchedule();
    this.$store.dispatch("counterUpdate", { count: this.schedule.length });
  },
};

export default schedule;


// WEBPACK FOOTER //
// ./src/mixins/schedule.js